(function ($) {
  // copied from jsonrpc.js as getAllItems doesn't return the right objects...
  var CartItem = function (itemData) {
      this.product = {
        sku: {}
      };
      var prodRegEx = /^prod\.(.+)$/;
      var skuRegEx = /sku\.(.+)$/;
      var prodObj = { sku: {} };

      for (var prop in itemData) {
        var newPropName = null;
        var prodResult = prop.match(prodRegEx);

        if (prodResult && prodResult[1]) {
          newPropName = prodResult[1];
          this.product[newPropName] = itemData[prop];
        }
        if (!newPropName) {
          var skuResult = prop.match(skuRegEx);

          if (skuResult && skuResult[1]) {
            newPropName = skuResult[1];
            this.product.sku[newPropName] = itemData[prop];
          }
        }
        if (!newPropName) {
          this[prop] = itemData[prop];
        }
      }
    },

    onComplete = function (cartResultObj) {
      var html = '';

      $.each(cartResultObj.getAllItems(), function () {
        var item = new CartItem(this),
          sku = item.product.sku,
          shadeHex = item.product.sku.HEX_VALUE_STRING;

        if (shadeHex != null) {
          // explode
          var shadeHex = shadeHex.split(',');

          if (shadeHex.length == 1) {
            sku['SWATCH_TYPE'] = 'single';
            sku['HEX_VALUE_1'] = shadeHex[0];
          } else if (shadeHex.length == 2) {
            sku['SWATCH_TYPE'] = 'duo';
            sku['HEX_VALUE_1'] = shadeHex[0];
            sku['HEX_VALUE_2'] = shadeHex[1];
          } else if (shadeHex.length == 3) {
            sku['SWATCH_TYPE'] = 'trio';
            sku['HEX_VALUE_1'] = shadeHex[0];
            sku['HEX_VALUE_2'] = shadeHex[1];
            sku['HEX_VALUE_3'] = shadeHex[2];
          } else if (shadeHex.length == 5) {
            sku['SWATCH_TYPE'] = 'quint';
            sku['HEX_VALUE_1'] = shadeHex[0];
            sku['HEX_VALUE_2'] = shadeHex[1];
            sku['HEX_VALUE_3'] = shadeHex[2];
            sku['HEX_VALUE_4'] = shadeHex[3];
            sku['HEX_VALUE_5'] = shadeHex[4];
          }
        }

        html += Mustache.render(site.cartConfirm.content, item);
      });

      // hide the multiple checkout buttons
      html = $(html);
      html.filter('a.button--secondary').hide().last().css({
        'display': 'block'
      });

      $('.cart-confirm__content').html(html).parent().fadeIn('200');

      // auto-hide
      setTimeout(function () {
        $('.cart-confirm__content').parent().fadeOut('200');
      }, 3500);
    };

  $('.add-all-to-bag').off('click').on('click', function () {
    generic.jsonrpc.fetch({
      'method': 'rpc.form',
      'params': [
        {
          '_SUBMIT': 'cart',
          'INCREMENT': 1,
          'QTY': 1,
          'SKU_BASE_ID': ($(this).attr('data-sku-base-ids') || '').split(',')
        }
      ],
      'onSuccess': function (jsonRpcResponse) {
        var data = jsonRpcResponse.getData(),
          cartResultObj = jsonRpcResponse.getCartResults();

        // load data
        if (data && data['trans_data']) {
          self._updateCartData(data['trans_data']);
        }

        cartResultObj.updateCountOnly = true;

        $(document).trigger('addToCart.success', [cartResultObj]);

        onComplete(cartResultObj);
      },
      'onFailure': function (jsonRpcResponse) {
        var errorObjectsArray = jsonRpcResponse.getMessages();

        $(document).trigger('addToCart.failure', [errorObjectsArray]);

        var cartResultObj = jsonRpcResponse.getCartResults();

        cartResultObj.updateCountOnly = true;
        $(document).trigger('addToCart.success', [cartResultObj]);

        onComplete(cartResultObj);
      }
    });

    return false;
  });
})(jQuery);
